<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { AuthAPI } from "./core/api";
import { mapMutations, mapState } from "vuex";
import { removeCredentials, setCredentials } from "./helpers/commons.helpers";
export default {
  data() {
    return {
      timer: 2 * (60 * 1000),
      seconds: 0,
      minutes: 0,
      count: null
    };
  },
  created() {},
  watch: {
    $route: {
      handler: function(current, old) {
        if (current.name !== "") {
          let path = current;
          let expired =
            localStorage.getItem("es-expired") === "true" ? true : false;
          if (path.meta.requiresAuth && expired) {
            this.logoOut();
          } else if (!path.meta.requiresAuth) {
            localStorage.setItem("es-expired", false);
          }
        }
      },
      deep: true
    },
    isIdle: {
      handler: async function(current, old) {
        if (current) {
          if (this.$route.meta.requiresAuth) {
            await this.alertSesion();
          }
        }
      },
      deep: true
    },
    sigout: {
      handler: async function(current, old) {
        if (current) {
          if (this.$route.meta.requiresAuth) {
            localStorage.setItem("es-expired", true);
            await this.sesionFinish();
          }
        }
      },
      deep: true
    }
  },
  methods: {
    async alertSesion() {
      this.seconds = 59;
      this.minutes = 1;
      let { value, dismiss } = await Swal.fire({
        title: "Are you still there?",
        html:
          "For your security, your RhomTrip session expires after 4 hours. <div class='space'></div> You current session is about to expire in <strong>02:00 minutes</strong>. <div class='space'></div> Do you want to <strong>save changes</strong>?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: "Continue in session",
        confirmButtonText: "Logout and end",
        timer: this.timer,
        onOpen: () => {
          this.count = setInterval(() => {
            if (this.seconds === 0) {
              this.minutes = this.minutes - 1;
              this.seconds = 60;
            }
            this.seconds = this.seconds - 1;
            Swal.getContent().querySelector(
              "strong"
            ).textContent = `${this.parsertime(this.minutes)}:${this.parsertime(
              this.seconds
            )}`;
          }, 1000);
        },
        onClose: () => {
          clearInterval(this.count);
        }
      });
      if (value) {
        localStorage.setItem("es-expired", true);
        await this.logoOut();
      } else if (dismiss === "timer") {
        localStorage.setItem("es-expired", true);
        await this.sesionFinish();
      } else if (dismiss === "cancel") {
        await this.refresToken();
      }
    },
    async sesionFinish() {
      let { value } = await Swal.fire({
        title: "Your session has expired",
        html:
          "For you security your current session has expired and you have been logged out. ",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: true,
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: "Accept"
      });
      if (value) {
        this.logoOut();
      }
    },
    async logoOut() {
      this.setResponseReservations({});
      this.setOperatorRespose({});
      this.setResponseBranch({});
      removeCredentials();
      this.setSesion(null);
      this.$router.push("/signin");
    },
    parsertime(time) {
      return (time >= 0) & (time < 10) ? `0${time}` : time;
    },
    async refresToken() {
      try {
        let { data } = await AuthAPI.refreshToken(this.sesion.token);
        if (data.status) {
          let sesion = data.data;
          if (sesion.token !== null) {
            sesion["status"] = true;
            setCredentials(sesion);
            this.setSesion(sesion);
            this.setSigOut(false);
          } else {
            localStorage.setItem("es-expired", true);
            this.setSigOut(false);
            this.logoOut();
          }
        } else {
          localStorage.setItem("es-expired", true);
          this.setSigOut(false);
          this.logoOut();
        }
      } catch (error) {
        localStorage.setItem("es-expired", true);
        this.setSigOut(false);
        this.logoOut();
      }
    },
    ...mapMutations([
      "setSesion",
      "setResponseReservations",
      "setOperatorRespose",
      "setResponseBranch",
      "setSigOut"
    ])
  },
  computed: {
    ...mapState(["sesion", "sigout"]),
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    }
  }
};
</script>
